module.exports = __webpack_public_path__ + "img/5PNG_Cover.5214de38.jpg";